import { createSlice } from "@reduxjs/toolkit";
import { OnboardingFormDetails, OnboardingListDetails } from "./Types";

type initialStateType = {
  onboardingDetailList: OnboardingListDetails[];
  onboardingDetailById?: OnboardingFormDetails | null;
  status: {
    onboardingDetailListLoading: boolean;
    onboardingDetailByIdLoading?: boolean;
    addOnboardingDetailLoading: boolean;
    addOnboardingDetailStatus: boolean;
    addOnboardingDetailMessage: string;
    updateOnboardingDetailLoading: boolean;
    updateOnboardingDetailStatus: boolean;
    updateOnboardingDetailMessage: string;
    updateOnboardingConfirmationRequired: boolean;
    deleteOnboardingDetailLoading: boolean;
    deleteOnboardingDetailStatus: boolean;
    updateProjectNameLoading: boolean;
    updateProjectNameStatus: boolean;
    updateProjectNameMessage: string;
  };
};

var initialState: initialStateType = {
  onboardingDetailList: [],
  onboardingDetailById: null,
  status: {
    onboardingDetailListLoading: false,
    onboardingDetailByIdLoading: false,
    addOnboardingDetailLoading: false,
    addOnboardingDetailStatus: false,
    addOnboardingDetailMessage: "",
    updateOnboardingDetailLoading: false,
    updateOnboardingDetailStatus: false,
    updateOnboardingDetailMessage: "",
    updateOnboardingConfirmationRequired: false,
    deleteOnboardingDetailLoading: false,
    deleteOnboardingDetailStatus: false,
    updateProjectNameLoading: false,
    updateProjectNameStatus: false,
    updateProjectNameMessage: "",
  },
};

const onboardingFormSlice = createSlice({
  name: "onboarding-form",
  initialState: initialState,
  reducers: {
    setOnboardingDetailList: (state, action) => {
      state.onboardingDetailList = action.payload;
    },
    setOnboardingDetailListLoading: (state, action) => {
      state.status.onboardingDetailListLoading = action.payload;
    },
    setOnboardingDetailById: (state, action) => {
      state.onboardingDetailById = action.payload;
    },
    setOnboardingDetailByIdLoading: (state, action) => {
      state.status.onboardingDetailByIdLoading = action.payload;
    },
    setAddOnboardingDetailLoading: (state, action) => {
      state.status.addOnboardingDetailLoading = action.payload;
    },
    setAddOnboardingDetailStatus: (state, action) => {
      state.status.addOnboardingDetailStatus = action.payload;
    },
    setAddOnboardingDetailMessage: (state, action) => {
      state.status.addOnboardingDetailMessage = action.payload;
    },
    setUpdateOnboardingDetailLoading: (state, action) => {
      state.status.updateOnboardingDetailLoading = action.payload;
    },
    setUpdateOnboardingDetailStatus: (state, action) => {
      state.status.updateOnboardingDetailStatus = action.payload;
    },
    setUpdateOnboardingDetailMessage: (state, action) => {
      state.status.updateOnboardingDetailMessage = action.payload;
    },
    setUpdateOnboardingConfirmationRequired: (state, action) => {
      state.status.updateOnboardingConfirmationRequired = action.payload;
    },
    clearUpdateOnboardingConfirmation: (state) => {
      state.status.updateOnboardingConfirmationRequired = false;
    },
    setDeleteOnboardingDetailLoading: (state, action) => {
      state.status.deleteOnboardingDetailLoading = action.payload;
    },
    setDeleteOnboardingDetailStatus: (state, action) => {
      state.status.deleteOnboardingDetailStatus = action.payload;
    },
    setUpdateProjectNameLoading: (state, action) => {
      state.status.updateProjectNameLoading = action.payload;
    },
    setUpdateProjectNameStatus: (state, action) => {
      state.status.updateProjectNameStatus = action.payload;
    },
    setUpdateProjectNameMessage: (state, action) => {
      state.status.updateProjectNameMessage = action.payload;
    },
    updateProjectNameInList: (state, action) => {
      const { old_project_name, new_project_name } = action.payload;
      // Update project name in the onboardingDetailList
      state.onboardingDetailList = state.onboardingDetailList.map(project => {
        if (project.project_name === old_project_name) {
          return {
            ...project,
            project_name: new_project_name
          };
        }
        return project;
      });
    },
  },
});

export const onboardingFormSliceReducer = onboardingFormSlice.reducer;
export const onboardingFormSliceAction = onboardingFormSlice.actions;
